import React from "react";
import icon1 from "./../../../images/goals/1.png";
import icon2 from "./../../../images/goals/2.png";
import icon3 from "./../../../images/goals/3.png";
import icon4 from "./../../../images/goals/4.png";
import icon5 from "./../../../images/goals/5.png";

const GoalCard = ({ icon, title, description }) => {
  return (
    <div className="flex flex-col items-center text-center p-4 max-w-[355px] min-w-[300px] flex-1">
      <div className="relative mb-4">
        <div className="w-20 h-20 rounded-full bg-[#1e6c56]"></div>
        <img
          src={icon}
          alt={title}
          className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-20 h-20"
        />
      </div>
      <h3 className="font-black text-2xl mb-2">{title}</h3>
      <p className="text-gray-700 text-base">{description}</p>
    </div>
  );
};

const GoalSection = ({ goals = defaultGoals }) => {
  return (
    <div className="flex flex-wrap justify-center gap-[60px] w-full max-w-[1189px] px-4">
      {goals.map((goal, index) => (
        <GoalCard
          key={index}
          icon={goal.icon}
          title={goal.title}
          description={goal.description}
        />
      ))}
    </div>
  );
};

const defaultGoals = [
  {
    icon: icon1,
    title: "Expand Language Access",
    description:
      "Support more African languages with accurate, culturally sensitive translations",
  },
  {
    icon: icon2,
    title: "Empower Developers",
    description:
      "Offer easy-to-use APIs for translation, text to speech, and speech to text features",
  },
  {
    icon: icon3,
    title: "Promote Digital Inclusion",
    description:
      "Ensure African languages are well-presented in digital tools and platforms",
  },
  {
    icon: icon4,
    title: "Support Diverse Applications",
    description:
      "Provide language solutions for various industries like education, media, business and healthcare",
  },
  {
    icon: icon5,
    title: "Enhance Quality And Accuracy",
    description:
      "Continuously improve our AI models for better context and tone accuracy",
  },
];

export default GoalSection;
